import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { DisclaimerAccordion } from './DisclaimerAccordion'
import { ExampleDiscountTable } from './ExampleDiscountTable'
import { HowItWorksTable } from './HowItWorksTable'

export const ProductInsurancePrescriptionBonusDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      data-qa-id="insurance-prescription-bonus-dialog"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="prescriptionBonus.modal.title.new" />
      </DialogTitle>
      <DialogContent>
        <div className="prose">
          <div className="my-2 text-xl font-medium">
            <FormattedMessage id="prescriptionBonus.modal.subtitle" />
          </div>
          <HowItWorksTable />
          <ExampleDiscountTable />
          <p className="py-4">
            <FormattedMessage id="prescriptionBonus.modal.outro" />
          </p>
          <DisclaimerAccordion />
        </div>
      </DialogContent>
    </Dialog>
  )
}
